import React from 'react';
import { Box } from '@mui/material';

// Components
import { ControlBar, ControlBarHeader, AdminPage } from 'components/ui/layout';
import ErrorLogList from './ErrorLogList';
import { LoadingState, ErrorState } from 'components/ui/states';

// API
import { useErrorLog } from './ErrorLogAPI';

export default function ErrorLog() {
    const errorLog = useErrorLog();

    return (
        <AdminPage>
            <Box display="flex" flexDirection="column" height="100%">
                <ControlBar>
                    <ControlBarHeader>Error Log</ControlBarHeader>
                </ControlBar>

                <Box display={'flex'} flex={1} width={'100%'}>
                    {errorLog && errorLog.length > 0 && <ErrorLogList errorLog={errorLog} />}
                    {errorLog && errorLog.length === 0 && (
                        <ErrorState message="There are no error logs to view" />
                    )}
                    {errorLog === null && <LoadingState />}
                </Box>
            </Box>
        </AdminPage>
    );
}
